import React from 'react'
import { Button } from 'antd'
import { PrinterOutlined } from '@ant-design/icons'
import { pdf } from '@react-pdf/renderer'
import * as FileSaver from 'file-saver'
import { post_catalog } from '../../../../escalas/estres_post_traumatico/post_traumatico/p_t_catalog'
import PostTraumaticoPDF from '../../printed-docs/printed-scales/post_traumatico-pdf'

// Example of post_traumatico: {"1":[0,4],"2":[1,3],"3":[2,2],"4":[3,1],"5":[4,0],"6":[2,2],"7":[0,4],"8":[1,3],"9":[2,2],"10":[3,1],"11":[4,0],"12":[2,2],"13":[0,4],"14":[1,3],"15":[2,2],"16":[3,1],"17":[0,3],"_id":"699537bfea650aa121668e13"}

// See the scala at: src\escalas\estres_post_traumatico\post_traumatico\p_t_encuesta.jsx

const frecuencias = ["Nunca", "A Veces", "2-3 Veces", "4-6 Veces", "A diario"]
const gravedades = ["Nada", "Leve", "Moderada", "Marcada", "Extrema"]

function getDavidsonInterpretation(score) {
    if (score <= 19) return 'Síntomas mínimos'
    if (score <= 39) return 'Síntomas leves'
    if (score <= 79) return 'Síntomas moderados'
    return 'Síntomas graves'
}

export default function PostTraumaticoResults({ post_traumatico, pacienteData, fecha }) {
    if (!post_traumatico) return null

    const score = post_catalog.reduce((total, _, i) => {
        const pair = post_traumatico[String(i + 1)]
        return pair ? total + (pair[0] || 0) + (pair[1] || 0) : total
    }, 0)

    const handlePrint = async () => {
        const blob = await pdf(<PostTraumaticoPDF pacienteData={pacienteData} fecha={fecha} post_traumatico={post_traumatico} />).toBlob()
        FileSaver.saveAs(blob, `post_traumatico_${pacienteData?.name || 'paciente'}.pdf`)
    }

    return (
        <div>
            <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#e6f4ff', padding: 5, borderRadius: 6 }}>
                <td><strong>Puntuación total: {score} / 136</strong></td>
                <td><strong>{getDavidsonInterpretation(score)}</strong></td>
            </tr>
            {post_catalog.map((pr, i) => {
                const pair = post_traumatico[String(i + 1)]
                return (
                    <tr key={i} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: i % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                        <td style={{ flex: 1 }}>{pr}</td>
                        <td style={{ whiteSpace: 'nowrap', paddingLeft: 8 }}>F: {pair ? frecuencias[pair[0]] : '-'}</td>
                        <td style={{ whiteSpace: 'nowrap', paddingLeft: 8 }}>G: {pair ? gravedades[pair[1]] : '-'}</td>
                    </tr>
                )
            })}
            <div style={{ marginTop: 10, textAlign: 'right' }}>
                <Button icon={<PrinterOutlined />} onClick={handlePrint}>Imprimir escala en pdf</Button>
            </div>
        </div>
    )
}
